import React, { useState, useEffect } from 'react';
import { Plane, Box, Sphere, Circle, Cone, Cylinder, Tube, Torus, TorusKnot, Ring, Tetrahedron, Polyhedron, Icosahedron, Octahedron, Dodecahedron, Extrude, Lathe } from "@react-three/drei";
import * as THREE from 'three'
import JsxParser from 'react-jsx-parser'
import { getSpecificAIModel } from '../api'
import { useObjectStore } from "../zustand/objects";


export default function AIModel({ prompt, clickFunction, colour, guestMode, projectKey, aiKey }) {
    const {
        aiModels,
        objectsAreLoaded
    } = useObjectStore();

// console.log(aiKey)

    const [jsx, setJSX] = useState(null)
 

    const thisModel = aiModels.find(item => item.prompt === prompt) && aiModels.find(item => item.prompt === prompt).jsx.replace('<>', "").replace('</>', "").replace(/\s+/g, ' ').trim().replace(/> </g, '><').replace(/\/>/g, "receiveShadow material-color={color} material={MeshStandardMaterial}/>")

    useEffect(() => {
        // !guestMode ? aiModels.length && getSpecificAIModel(prompt).then((res) => setJSX(res.jsx))
        // guestMode && objectsAreLoaded && getSpecificAIModel({prompt: prompt, projectKey: projectKey}).then((res) => setJSX(res.jsx.replace('<>', "").replace('</>', "").replace(/\s+/g, ' ').trim().replace(/> </g, '><').replace(/\//g, "receiveShadow material-color={color} material={MeshStandardMaterial}/")))
        if (!guestMode || !objectsAreLoaded) return;

        getSpecificAIModel(aiKey).then((res) =>
            setJSX(
                res.jsx
                    .replace("<>", "")
                    .replace("</>", "")
                    .replace(/\s+/g, " ")
                    .trim()
                    .replace(/> </g, "><")
                    .replace(/\/>$/g, 'receiveShadow material-color={color} material={MeshStandardMaterial}/>')
            )
        );
    }, [aiKey, guestMode, objectsAreLoaded])

    


    return (
        <group visible={colour ? true : false} dispose={null} onClick={(e) => {
            e.stopPropagation()
            clickFunction()
        }}>
            
            <JsxParser
                componentsOnly={true}
                renderInWrapper={false}
                bindings={{ color: colour, MeshStandardMaterial: new THREE.MeshStandardMaterial() }}
                components={{ THREE, Plane, Box, Sphere, Circle, Cone, Cylinder, Tube, Torus, TorusKnot, Ring, Tetrahedron, Polyhedron, Icosahedron, Octahedron, Dodecahedron, Extrude, Lathe }}
                jsx={guestMode ? jsx : objectsAreLoaded && thisModel}
            />

        </group>
    );
}

